module.exports = __webpack_public_path__ + "img/logo-ec.4edce980.png";